export function getWrapperClassName(isPending: boolean, isIntegrated = false, isMarketing = false) {
    return `vyne-payment-landing-metrics-wrapper ${isPending ? "vyne-metrics-loading" : ""} ${isIntegrated && !isMarketing ? "vyne-metrics-integrated" : ""}`;
}

export function getClassName(isPlaceholderData: boolean) {
    return `vyne-payments-landing-metrics ${isPlaceholderData ? "is-previous-data" : ""}`;
}
